module.exports = __webpack_public_path__ + "img/tg.95cfc626.svg";